<template lang='pug'>
  r-form(
    ref='form'
    v-bind='formProps'
    v-model='slCustomer'
    @reset='submitRefresh'
  )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  //
  import SlCustomerFields from '@/views/Sale/SlCustomer/SlCustomerFields'
  import SlCustomerModel from '@/models/Sale/SlCustomer'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: SlCustomerFields
            .include([
              'title_general',
              'rut',
              'alias_name',
              'business_name',
              'core_business',
              'email_collection',
              'branch_offices',
            ])
            .readonly(),
          noSubmit: true,
          resetText: 'refrescar',
        }
      },
    },
    data() {
      return {
        slCustomer: {},
      }
    },
    methods: {
      getSlCustomer() {
        return SlCustomerModel
          .append('branch_offices')
          .include('branch_offices.sl_customer_ground_seller.sl_ground_seller.hr_employee')
          .find(this.$route.params.id)
      },
      setSlCustomer(slCustomer) {
        this.slCustomer = slCustomer.reset()
      },
      submitRefresh(event) {
        this
          .toWait(true)
          .then(this.toRefresh)
          .then(this.toWait)
      },
      toRefresh() {
        return this
          .getSlCustomer()
          .then(this.setSlCustomer)
      },
      toWait(wait = false) {
        return this
          .$refs
          .form
          .setWait(wait)
      },
    },
    mounted() {
      this.toRefresh()
    },
  }
</script>
